import React, { useEffect, useRef, useState } from "react";
import useWebSocket from "react-use-websocket";
import { useTranslation } from "react-i18next";
import {
  delay,
  findGetParameter,
  getData,
  getIntegerFromString,
  getWSAuth,
  newPath,
  useInterval
} from "../../../../components/utilities/UtilityFunctions";
import { useNavigate } from "react-router";
import { useConfirm } from "material-ui-confirm";
import { postNotification } from "../../../../components/utilities/Notifications";
import EventPairingsDefault from "./EventPairingsDefault";
import {
  getWebsocketUrl,
  refreshPairings as refreshPairingsFunc,
  userDisplayName
} from "../EventFunctions";
import { handlePagingAll } from "../../../../components/api/APIUtilities";
import { getCurrentRound } from "../EventPairings";

const WEBSOCKET_URL = getWebsocketUrl();

export default function EventPairingsWS(props) {
  const { t } = useTranslation();
  const {
    activeTab,
    handleTabChange,
    event,
    setEvent,
    organize,
    authContext,
    setResetModalOpen
  } = props;

  const [refreshPairings, setRefreshPairings] = useState(false);
  const [loading, setLoading] = useState(false);
  const [subLoading, setSubLoading] = useState(true);
  const [roundNo, setRoundNo] = useState(null);

  const [pairings, setPairings] = useState(null);

  const [timerData, setTimerData] = useState(null);

  const [triggerHandlePairingStatus, setTriggerHandlePairingStatus] =
    useState(false);
  const [pairingStatus, setPairingStatus] = useState(null);
  const [pairingProgress, setPairingProgress] = useState(0);

  const [optionsAnchorEl, setOptionsAnchorEl] = useState(null);

  const [pairingPopUp, setPairingPopUp] = useState(null);
  const [optionsAnchorEl4, setOptionsAnchorEl4] = useState(null);
  const [optionsAnchorEl5, setOptionsAnchorEl5] = useState(null);
  const [optionsAnchorEl6, setOptionsAnchorEl6] = useState(null);

  const [optionsAnchorEl2, setOptionsAnchorEl2] = useState(null);
  const [pairing, setPairing] = useState(null);
  const [teamPairing, setTeamPairing] = useState(null);
  const [seatedPairing, setSeatedPairing] = useState(null);
  const [, setSoftScorePairings] = useState(null);

  const [player, setPlayer] = useState(null);
  const [teamPlayer, setTeamPlayer] = useState(null);

  const [placingsReady, setPlacingsReady] = useState(
    getCurrentRound(event) !== roundNo ? true : false
  );
  const [players, setPlayers] = useState(null);

  const [armyModalOpen, setArmyModalOpen] = useState(false);
  const [swapPlayerModal, setSwapPlayerModal] = useState(false);
  const [swapTeamModal, setSwapTeamModal] = useState(false);
  const [swapSeatedPairingModal, setSwapSeatedPairingModal] = useState(false);
  const [swapSeatNumberModal, setSwapSeatNumberModal] = useState(false);

  const [swapTableModal, setSwapTableModal] = useState(false);

  const [createPairingModal, setCreatePairingModal] = useState(false);

  const [roundTimerOptions, setRoundTimerOptions] = useState(null);
  const [topCutOptions, setTopCutOptions] = useState(null);
  const [endEventModal, setEndEventModal] = useState(false);

  const [filtersAnchorEl, setFiltersAnchorEl] = useState(null);
  const [filteredPairings, setFilteredPairings] = useState(null);
  const [filterType, setFilterType] = useState("");

  // Used to add a slight delay before fetching round data when switching between multiple rounds
  const [_roundNo, set_RoundNo] = useState(roundNo);
  const [timer, setTimer] = useState(null);

  const navigate = useNavigate();
  const confirm = useConfirm();

  const [roundUpdating, setRoundUpdating] = useState(true);
  const [betweenRoundsModal, setBetweenRoundsModal] = useState(false);

  // WebSockets
  const [socketStatus, setSocketStatus] = useState(
    event?.status?.ended || !event?.status?.started ? "Disabled" : "Connecting"
  );
  const [pSocketUrl, setPSocketUrl] = useState(null);
  const webSocket = useWebSocket(pSocketUrl, {
    share: true,
    onOpen: () => {
      setRoundUpdating(false);
      setSocketStatus("Live");
    },
    onClose: () => {
      setSocketStatus("Disconnected");
    },
    shouldReconnect: false
  });

  // Checks if placings are up to date
  const checkStatus = async () => {
    if (
      event &&
      (!event?.status?.ended || getCurrentRound(event) === roundNo)
    ) {
      try {
        const apiStatus = await getData(`/events/${event.id}/updatestatus`);
        if (apiStatus?.status === "ready") {
          setPlacingsReady(true);
        }
        if (apiStatus?.status === "processing") {
          setPlacingsReady(false);
        }
      } catch (err) {
        setPlacingsReady(false);
      }
    }
  };

  const handlePodLabels = (newPods) => {
    if (Object.keys(newPods).length > 0) {
      if (event.topCut) {
        if (newPods[1]) {
          newPods[1].label = event.doubleElimination
            ? "Championship Bracket"
            : "Top Cut";
        }
        if (event.doubleElimination) {
          if (newPods[2]) {
            newPods[2].label = "Elimination Bracket";
          }
          if (newPods[3]) {
            newPods[3].label = "Eliminated Bracket";
          }
        }
      } else if (
        event.format?.pairingStyle === "single elimination" ||
        event.format?.pairingStyle === "double elimination"
      ) {
        if (newPods[1]) {
          newPods[1].label = "Championship Bracket";
        }
        if (newPods[2]) {
          newPods[2].label =
            event.format?.pairingStyle === "single elimination"
              ? "Eliminated Bracket"
              : "Elimination Bracket";
        }
        if (newPods[3]) {
          newPods[3].label = "Eliminated Bracket";
        }
      }
    }
  };

  // WTC pod phase, organizer page only, rounds 1-3: group the pairings by pod, then table, and show the pod number after the
  // team name. Safe to run again on the same list: a live update replaces the team objects, so the pod of each team is
  // remembered by team id and the suffix is never added twice.
  const wtcPodByTeamId = useRef({});
  const handleWtcPodGrouping = (list, round) => {
    if (!organize || !event?.flags?.wtcPodPhase || round > 3) return;
    const pods = wtcPodByTeamId.current;
    list.forEach((p) => {
      for (const key of ["teamPlayer1", "teamPlayer2"]) {
        if (p[key]?.id && p[key]?.podNum) pods[p[key].id] = p[key].podNum;
      }
    });
    const podOf = (p) =>
      pods[p.teamPlayer1?.id] ??
      pods[p.teamPlayer2?.id] ??
      p.player1?.podNum ??
      p.player2?.podNum ??
      Infinity;
    list.sort((a, b) => podOf(a) - podOf(b) || a.table - b.table);
    list.forEach((p) => {
      for (const key of ["teamPlayer1", "teamPlayer2"]) {
        const team = p[key];
        const pod = pods[team?.id];
        if (team?.name && pod) {
          const label = ` - Pod #${String(pod).padStart(2, "0")}`;
          if (!team.name.endsWith(label)) {
            p[key] = { ...team, name: `${team.name}${label}` };
          }
        }
      }
    });
  };

  const fetchSoftScorePairings = async (round) => {
    if (round === 0) return [];

    var returnArray = [];

    try {
      returnArray = await handlePagingAll("/pairings", {
        limit: 500,
        eventId: event.id,
        round: round,
        pairingType: "SoftScorePairing",
        "expand[]": ["player", "teamPlayer"]
      });
    } catch (err) {
      console.error(err);
      return undefined;
    }
    return returnArray;
  };

  const fetchPairings = async (round, params) => {
    if (round === 0) return [];

    var returnArray = [];

    let queryParams = {
      eventId: event.id,
      round: round,
      pairingType: "Pairing"
    };

    if (params) {
      queryParams = { ...queryParams, ...params };
    }
    try {
      const apiPairings = await getData(
        `/events/${event?.id}/pairings`,
        queryParams
      );

      if (apiPairings?.active?.length) {
        returnArray = apiPairings.active;
      }

      if (returnArray?.length) {
        if (!event?.format?.teamEvent || event?.format?.doublesEvent) {
          var newPods = {};
          var hasPods = false;
          returnArray.forEach((p) => {
            if (
              (p.podNum === undefined && !newPods["undefined"]) ||
              !newPods[p.podNum]
            ) {
              newPods[p.podNum !== undefined ? p.podNum : "undefined"] = {
                isPod: true,
                podNum: p.podNum
              };
              if (!hasPods && p.podNum !== undefined) hasPods = true;
            }
          });
          handlePodLabels(newPods);
          if (hasPods) returnArray.push(...Object.values(newPods));
        }

        returnArray.sort((a, b) => {
          if (a?.podNum && !b?.podNum) return -1;
          if (!a?.podNum && b?.podNum) return 1;
          if (a?.podNum < b?.podNum) return -1;
          if (a?.podNum > b?.podNum) return 1;
          if (a?.isPod && !b?.isPod) return -1;
          if (!a?.isPod && b?.isPod) return 1;
          if (a?.table !== undefined && a?.table === undefined) return -1;
          if (a?.table === undefined && a?.table !== undefined) return 1;

          return a?.table - b?.table;
        });
        handleWtcPodGrouping(returnArray, round);
      }
    } catch (err) {
      console.error(err);
      return undefined;
    }
    return returnArray;
  };

  const fetchSeatedPairings = async (round, params) => {
    if (round === 0) return [];

    var returnArray = [];
    let queryParams = {
      eventId: event.id,
      round: round,
      pairingType: "SeatedPairing"
    };
    if (params) {
      queryParams = { ...queryParams, ...params };
    }

    try {
      const apiPairings = await getData(
        `/events/${event?.id}/pairings`,
        queryParams
      );

      if (apiPairings?.active?.length) {
        returnArray = apiPairings.active;
      }

      if (returnArray?.length) {
        if (!event?.format?.teamEvent || event?.format?.doublesEvent) {
          var newPods = {};
          var hasPods = false;
          returnArray.forEach((p) => {
            if (
              (p.podNum === undefined && !newPods["undefined"]) ||
              !newPods[p.podNum]
            ) {
              newPods[p.podNum !== undefined ? p.podNum : "undefined"] = {
                isPod: true,
                podNum: p.podNum
              };
              if (!hasPods && p.podNum !== undefined) hasPods = true;
            }
          });
          handlePodLabels(newPods);
          if (hasPods) returnArray.push(...Object.values(newPods));
        }

        returnArray.sort((a, b) => {
          if (a.podNum && !b.podNum) return -1;
          if (!a.podNum && b.podNum) return 1;
          if (a.podNum < b.podNum) return -1;
          if (a.podNum > b.podNum) return 1;
          if (a.isPod && !b.isPod) return -1;
          if (!a.isPod && b.isPod) return 1;
          if (a.table !== undefined && a.table === undefined) return -1;
          if (a.table === undefined && a.table !== undefined) return 1;

          return a.table - b.table;
        });
      }
    } catch (err) {
      console.error(err);
      return undefined;
    }
    return returnArray;
  };

  const fetchTeamPairings = async (round, params) => {
    if (round === 0) return [];
    var returnArray = [];
    let queryParams = {
      eventId: event.id,
      round: round,
      pairingType: "TeamPairing"
    };

    if (params) {
      queryParams = { ...queryParams, ...params };
    }

    try {
      const apiPairings = await getData(
        `/events/${event?.id}/pairings`,
        queryParams
      );

      if (apiPairings?.active?.length) {
        returnArray = apiPairings.active;
      }

      if (returnArray?.length) {
        var newPods = {};
        var hasPods = false;
        returnArray.forEach((p) => {
          if (
            (p.podNum === undefined && !newPods["undefined"]) ||
            !newPods[p.podNum]
          ) {
            newPods[p.podNum !== undefined ? p.podNum : "undefined"] = {
              isPod: true,
              podNum: p.podNum
            };
            if (!hasPods && p.podNum !== undefined) hasPods = true;
          }
        });
        handlePodLabels(newPods);
        if (hasPods) returnArray.push(...Object.values(newPods));

        returnArray.sort((a, b) => {
          if (a.podNum && !b.podNum) return -1;
          if (!a.podNum && b.podNum) return 1;
          if (a.podNum < b.podNum) return -1;
          if (a.podNum > b.podNum) return 1;
          if (a.isPod && !b.isPod) return -1;
          if (!a.isPod && b.isPod) return 1;
          if (a.table !== undefined && a.table === undefined) return -1;
          if (a.table === undefined && a.table !== undefined) return 1;

          return a.table - b.table;
        });
        handleWtcPodGrouping(returnArray, round);
      }
    } catch (err) {
      console.error(err);
      return undefined;
    }
    return returnArray;
  };

  async function parallel(round) {
    let queryParams = {};

    const isBoardGameEvent = Boolean(
      event?.boardGameEvent || event?.format?.boardGameEvent
    );
    const isDoublesEvent = Boolean(
      event?.doublesEvent || event?.format?.doublesEvent
    );
    const isTeamEvent = Boolean(event?.teamEvent || event?.format?.teamEvent);

    const taskPairings =
      !isBoardGameEvent && !isDoublesEvent
        ? fetchPairings(round, queryParams)
        : [];
    const taskTeamPairings =
      !isBoardGameEvent && isTeamEvent
        ? fetchTeamPairings(round, queryParams)
        : [];
    const taskSeatedPairings = isBoardGameEvent
      ? fetchSeatedPairings(round, queryParams)
      : [];
    const taskSoftScorePairings = organize ? fetchSoftScorePairings(round) : [];
    const taskPlayers = fetchPlayers();
    const taskTeamPlayers = event?.format?.teamEvent ? fetchTeamPlayers() : [];

    return {
      pairings: await taskPairings,
      teamPairings: await taskTeamPairings,
      players: await taskPlayers,
      teamPlayers: await taskTeamPlayers,
      seatedPairings: await taskSeatedPairings,
      softScorePairings: await taskSoftScorePairings
    };
  }

  const fetchPlayers = async () => {
    if (
      !(organize || event?.boardGameEvent || event?.format?.boardGameEvent) &&
      !event?.doublesEvent &&
      !event?.format?.doublesEvent
    )
      return [];
    if (event?.id === "7CA6VVLL6P") return [];
    const returnArray = [];
    try {
      const apiPlayers = await getData(`/events/${event?.id}/players`);

      if (apiPlayers && apiPlayers?.active?.length) {
        returnArray.push(...apiPlayers.active);
      }

      if (!returnArray || !returnArray?.length) {
        return [];
      }
    } catch (err) {
      console.error(err);
      return [];
    }
    return returnArray?.filter((el) => el?.checkedIn);
  };

  const fetchTeamPlayers = async () => {
    if (event?.id === "7CA6VVLL6P") return [];
    var returnArray = [];
    try {
      const apiTeamPlayers = await getData(`/events/${event?.id}/teamPlayers`, {
        placings: false
      });
      if (apiTeamPlayers?.active?.length) {
        returnArray = apiTeamPlayers.active;
      }
    } catch (err) {
      console.log(err);
      return undefined;
    }
    return returnArray;
  };

  // Establishes websocket connection
  const handleWSConnection = async (roundNum) => {
    setSocketStatus("Connecting");

    const setSocketUrl = (endpoint, setSocket) =>
      setSocket(`${WEBSOCKET_URL}?connectionToken=${endpoint}`);

    let options = {
      eventId: event.id,
      connectionType: "eventPairings",
      pairingType:
        event?.doublesEvent ||
        event?.teamEvent ||
        event?.format?.doublesEvent ||
        event?.format?.teamEvent
          ? "TeamPairing"
          : event?.boardGameEvent || event?.format?.boardGameEvent
            ? "BCPSeatedPairing"
            : "Pairing"
    };

    const round = roundNum || roundNo || _roundNo;

    if (round) {
      options.round = round;
    }

    const webSocketAuth = await getWSAuth(options);

    setSocketUrl(webSocketAuth, setPSocketUrl);
  };

  // Handles incoming websocket messages
  const handleMessages = (ws) => {
    if (ws?.lastMessage !== null) {
      const lastMessage = JSON.parse(ws.lastMessage?.data);

      const currentPairing = lastMessage?.data;
      let tempPairings = pairings;

      if (
        event?.format?.doublesEvent &&
        currentPairing?.pairingType === "Pairing"
      )
        return;

      if (lastMessage?.status === "updated" && currentPairing) {
        if (tempPairings && tempPairings.length) {
          let found = false;
          // Filter through and update placings/players if need be
          let updatedPairings = tempPairings.map((pairing) => {
            if (event?.format?.doublesEvent) {
              if (pairing?.id === currentPairing?.id) {
                // Clears scores if the TO has cleared scores
                if (pairing?.player1Game && !currentPairing?.player1Game)
                  delete pairing.player1Game;
                if (pairing?.player2Game && !currentPairing?.player2Game)
                  delete pairing.player2Game;

                // Adds `players` array to pairing `teamPlayer` object
                if (players && players?.length) {
                  const getPlayers = (team) =>
                    team?.players && team.players.length
                      ? [...team.players]
                      : [];

                  const players1 = getPlayers(pairing?.teamPlayer1);
                  const players2 = getPlayers(pairing?.teamPlayer2);

                  players.forEach((player) => {
                    const { teamPlayerId, id } = player;

                    const updatePlayers = (teamPlayers) => {
                      if (teamPlayers.length) {
                        teamPlayers.forEach((_player, i) => {
                          if (_player.id === id) {
                            teamPlayers[i] = _player;
                          }
                        });
                      } else {
                        teamPlayers.push(player);
                      }
                    };

                    if (
                      teamPlayerId === pairing?.teamPlayer1Id ||
                      teamPlayerId === pairing?.teamPlayer1?.id
                    ) {
                      updatePlayers(players1);
                    } else if (
                      teamPlayerId === pairing?.teamPlayer2Id ||
                      teamPlayerId === pairing?.teamPlayer2?.id
                    ) {
                      updatePlayers(players2);
                    }
                  });

                  if (currentPairing?.teamPlayer1)
                    currentPairing.teamPlayer1.players = players1;
                  if (currentPairing?.teamPlayer2)
                    currentPairing.teamPlayer2.players = players2;
                }

                const newPairing = { ...pairing, ...currentPairing };
                found = true;

                return newPairing;
              } else {
                return pairing;
              }
            } else if (event?.format?.teamEvent) {
              if (currentPairing?.pairingType === "TeamPairing") {
                // If team already has team members attached then copy it over to new message then replace existing pairing slot with new teamPairing
                if (pairing?.id === currentPairing?.id) {
                  // Combines the two without deleting important information (such as individual pairings)
                  found = true;

                  // Clears scores if the TO has cleared scores
                  if (pairing?.player1Game && !currentPairing?.player1Game)
                    delete pairing.player1Game;
                  if (pairing?.player2Game && !currentPairing?.player2Game)
                    delete pairing.player2Game;

                  const newPairing = { ...pairing, ...currentPairing };

                  return newPairing;
                } else {
                  return pairing;
                }
              } else {
                // Looks for existing child within parent Team Pairing
                if (pairing?.id === currentPairing?.teamPairingId) {
                  found = true;
                  if (pairing?.pairings?.length) {
                    let _found = false;

                    // Replace single pairing if it already exists in array
                    pairing.pairings.forEach((_pairing, i) => {
                      if (_pairing.id === currentPairing.id) {
                        pairing.pairings[i] = currentPairing;
                        _found = true;
                      }
                    });

                    // If no such pairing exists yet, then push into pairings array
                    if (!_found) {
                      pairing.pairings.push(currentPairing);
                    }
                  } else {
                    pairing.pairings = [currentPairing];
                  }

                  return pairing;
                } else {
                  return pairing;
                }
              }
            } else {
              if (pairing?.pairingType === "BCPSeatedPairing")
                pairing.pairingType = "SeatedPairing";
              if (currentPairing?.pairingType === "BCPSeatedPairing")
                currentPairing.pairingType = "SeatedPairing";

              if (pairing?.id === currentPairing?.id) {
                found = true;
                return currentPairing;
              }
              return pairing;
            }
          });

          if (!found) {
            updatedPairings = [...updatedPairings, currentPairing];
          }

          tempPairings = updatedPairings;
        } else {
          tempPairings = [currentPairing];
        }
      }

      if (lastMessage?.status === "deleted") {
        if (tempPairings && tempPairings?.length) {
          tempPairings = tempPairings.filter(
            (pairing) => pairing?.id !== lastMessage?.id
          );
        }
      }

      if (tempPairings?.length) {
        tempPairings.sort((a, b) => a?.table - b?.table);
        handleWtcPodGrouping(tempPairings, roundNo);

        // Set and store relevent data
        setPairings(tempPairings);
      }
    }
  };

  const handlePairings = async (round) => {
    if (round === 0) {
      setPairings([]);
      setSoftScorePairings([]);
      setSubLoading(false);
    }
    setSubLoading(true);
    try {
      var parallelData = await parallel(round);

      if (organize) {
        let softScores = event?.softScores?.filter(
          (el) => el.playerScored && el.roundByRound
        );
        if (softScores?.length) {
          // handle soft score stuff
          let tempSoftScoreDict = {};
          if (parallelData.softScorePairings?.length) {
            for (let softScorePairing of parallelData.softScorePairings) {
              if (!tempSoftScoreDict[softScorePairing.softScoreId]) {
                tempSoftScoreDict[softScorePairing.softScoreId] = {};
              }
              if (softScorePairing.parentPairingId) {
                if (
                  !tempSoftScoreDict[softScorePairing.softScoreId][
                    softScorePairing.parentPairingId
                  ]
                ) {
                  tempSoftScoreDict[softScorePairing.softScoreId][
                    softScorePairing.parentPairingId
                  ] = {};
                }
                if (softScorePairing.playerId) {
                  tempSoftScoreDict[softScorePairing.softScoreId][
                    softScorePairing.parentPairingId
                  ][softScorePairing.playerId] = softScorePairing;
                } else if (softScorePairing.byePlayer) {
                  tempSoftScoreDict[softScorePairing.softScoreId][
                    softScorePairing.parentPairingId
                  ]["byePlayer"] = softScorePairing;
                }
              } else {
                // TODO: build others
              }
            }
          }

          // TODO: build non singles event logic

          for (let i = 0; i < parallelData.pairings?.length; i++) {
            for (let softScore of softScores) {
              if (!parallelData.pairings[i].player1SoftScores) {
                parallelData.pairings[i].player1SoftScores = [];
              }
              if (!parallelData.pairings[i].player2SoftScores) {
                parallelData.pairings[i].player2SoftScores = [];
              }

              if (parallelData.pairings[i].player1Id) {
                if (parallelData.pairings[i].player2Id) {
                  let softScorePairing = tempSoftScoreDict[softScore.id]?.[
                    parallelData.pairings[i].id
                  ]?.[parallelData.pairings[i].player1Id] || {
                    isDone: false
                  };
                  softScorePairing.softScore = softScore;
                  parallelData.pairings[i].player1SoftScores.push(
                    softScorePairing
                  );
                } else {
                  parallelData.pairings[i].player1SoftScores.push({
                    playerId: parallelData.pairings[i].player1Id,
                    isDone: true,
                    byeOpponent: true,
                    softScore: softScore
                  });
                }
              } else if (parallelData.pairings[i].player2Id) {
                let softScorePairing = tempSoftScoreDict[softScore.id]?.[
                  parallelData.pairings[i].id
                ]?.["byePlayer"] || {
                  isDone: false
                };
                softScorePairing.softScore = softScore;
                parallelData.pairings[i].player1SoftScores.push(
                  softScorePairing
                );
              }

              if (parallelData.pairings[i].player2Id) {
                if (parallelData.pairings[i].player1Id) {
                  let softScorePairing = tempSoftScoreDict[softScore.id]?.[
                    parallelData.pairings[i].id
                  ]?.[parallelData.pairings[i].player2Id] || {
                    isDone: false
                  };
                  softScorePairing.softScore = softScore;
                  parallelData.pairings[i].player2SoftScores.push(
                    softScorePairing
                  );
                } else {
                  // BYE
                  parallelData.pairings[i].player2SoftScores.push({
                    playerId: parallelData.pairings[i].player2Id,
                    isDone: true,
                    byeOpponent: true,
                    softScore: softScore
                  });
                }
              } else if (parallelData.pairings[i].player1Id) {
                let softScorePairing =
                  tempSoftScoreDict[softScore.id]?.[
                    parallelData.pairings[i].id
                  ]?.["byePlayer"] || {};
                softScorePairing.softScore = softScore;
                parallelData.pairings[i].player2SoftScores.push(
                  softScorePairing
                );
              }
            }
          }
        }
      }

      if (
        !organize &&
        event?.adepticonTeamEvent &&
        parallelData.teamPairings?.length
      ) {
        let teamPairingsDict = {};
        if (parallelData.pairings?.length) {
          parallelData.pairings.forEach((pairing) => {
            if (pairing.teamPairingId) {
              if (!teamPairingsDict[pairing.teamPairingId]) {
                teamPairingsDict[pairing.teamPairingId] = [];
              }
              teamPairingsDict[pairing.teamPairingId].push(pairing);
            }
          });
        }

        let playersDict = {};
        if (parallelData.players?.length) {
          parallelData.players.forEach((player) => {
            playersDict[player.id] = player;
          });
        }

        let teamPairingsMerged = {};
        if (parallelData.teamPairings?.length) {
          parallelData.teamPairings.forEach((pairing) => {
            if (teamPairingsDict[pairing.id]) {
              pairing.pairings = teamPairingsDict[pairing.id];
            }
            if (
              pairing.teamPlayer1?.players?.length ||
              pairing.teamPlayer2?.players?.length
            ) {
              for (
                let i = 0;
                i < pairing.teamPlayer1?.players?.length ||
                i < pairing.teamPlayer2?.players?.length;
                i++
              ) {
                if (
                  pairing.teamPlayer1?.players?.[i]?.objectId &&
                  playersDict[pairing.teamPlayer1.players[i].objectId]
                ) {
                  pairing.teamPlayer1.players[i] =
                    playersDict[pairing.teamPlayer1.players[i].objectId];
                }
                if (
                  pairing.teamPlayer2?.players?.[i]?.objectId &&
                  playersDict[pairing.teamPlayer2.players[i].objectId]
                ) {
                  pairing.teamPlayer2.players[i] =
                    playersDict[pairing.teamPlayer2.players[i].objectId];
                }
              }
            }

            if (
              !teamPairingsMerged[
                `${pairing.teamPlayer1Id}-${pairing.teamPlayer2Id}`
              ]
            ) {
              teamPairingsMerged[
                `${pairing.teamPlayer1Id}-${pairing.teamPlayer2Id}`
              ] = pairing;
            } else {
              teamPairingsMerged[
                `${pairing.teamPlayer1Id}-${pairing.teamPlayer2Id}`
              ].secondaryTeamPairing = pairing;
            }
          });
        }

        parallelData.teamPairings = Object.values(teamPairingsMerged);
        parallelData.teamPairings.sort((a, b) => {
          return (a?.table || 0) - (b?.table || 0);
        });
      } else if (parallelData.teamPairings?.length) {
        // Adds missing player data for doubles events
        if (event?.format?.doublesEvent) {
          if (
            parallelData.players?.length &&
            parallelData.teamPairings?.length
          ) {
            parallelData.players.forEach((player) => {
              parallelData.teamPairings.forEach((pairing) => {
                if (player?.teamPlayerId == pairing?.teamPlayer1?.id) {
                  if (pairing?.teamPlayer1?.players?.length) {
                    pairing.teamPlayer1.players.push(player);
                  } else {
                    pairing.teamPlayer1.players = [player];
                  }
                }

                if (player?.teamPlayerId == pairing?.teamPlayer2?.id) {
                  if (pairing?.teamPlayer2?.players?.length) {
                    pairing.teamPlayer2.players.push(player);
                  } else {
                    pairing.teamPlayer2.players = [player];
                  }
                }
              });
            });
          }
        } else {
          let teamPairingsDict = {};
          if (parallelData.pairings?.length) {
            parallelData.pairings.forEach((pairing) => {
              if (pairing.teamPairingId) {
                if (!teamPairingsDict[pairing.teamPairingId]) {
                  teamPairingsDict[pairing.teamPairingId] = [];
                }
                teamPairingsDict[pairing.teamPairingId].push(pairing);
              }
            });
          }

          let playersDict = {};
          if (parallelData.players?.length) {
            parallelData.players.forEach((player) => {
              playersDict[player.id] = player;
            });
          }

          if (parallelData.teamPlayers?.length) {
            parallelData.teamPairings.forEach((pairing) => {
              if (teamPairingsDict[pairing.id]) {
                pairing.pairings = teamPairingsDict[pairing.id];
                if (event.adepticonTeamEvent) {
                  pairing.pairings.sort((a, b) => {
                    return a?.primaryPairingId === a?.id ? -1 : 1;
                  });
                }
              }
              if (
                pairing.teamPlayer1?.players?.length ||
                pairing.teamPlayer2?.players?.length
              ) {
                for (
                  let i = 0;
                  i < pairing.teamPlayer1?.players?.length ||
                  i < pairing.teamPlayer2?.players?.length;
                  i++
                ) {
                  if (
                    pairing.teamPlayer1?.players?.[i]?.objectId &&
                    playersDict[pairing.teamPlayer1.players[i].objectId]
                  ) {
                    pairing.teamPlayer1.players[i] =
                      playersDict[pairing.teamPlayer1.players[i].objectId];
                  }
                  if (
                    pairing.teamPlayer2?.players?.[i]?.objectId &&
                    playersDict[pairing.teamPlayer2.players[i].objectId]
                  ) {
                    pairing.teamPlayer2.players[i] =
                      playersDict[pairing.teamPlayer2.players[i].objectId];
                  }
                }
              }
            });
          }
        }
      }

      var playersArray = [];
      if (parallelData?.players?.length) {
        parallelData.players.forEach((player) => {
          player.name = userDisplayName(player?.firstName, player?.lastName);
          if (parallelData?.pairings?.length) {
            parallelData.pairings.forEach((pairing) => {
              if (
                pairing?.player1?.id === player?.id ||
                pairing?.player2?.id === player.id
              ) {
                player.pairing = pairing;
              }
            });
          }

          if (parallelData?.seatedPairings?.length) {
            parallelData.seatedPairings.forEach((pairing) => {
              pairing.seatedPlayers?.forEach((seatedPlayer, i) => {
                if (seatedPlayer?.playerId === player?.id) {
                  pairing.seatedPlayers[i] = {
                    ...seatedPlayer,
                    ...player?.user,
                    team: { ...player?.team },
                    table: pairing?.table
                  };
                }
              });
            });
          }

          playersArray.push(player);
        });
      } else {
        if (parallelData.pairings?.length) {
          parallelData.pairings.forEach((pairing) => {
            if (pairing.player1?.id) {
              pairing.player1.name = userDisplayName(
                pairing?.player1?.firstName,
                pairing?.player1?.lastName
              );
              playersArray.push(pairing.player1);
            }
            if (pairing.player2?.id) {
              pairing.player2.name = userDisplayName(
                pairing?.player2?.firstName,
                pairing?.player2?.lastName
              );
              playersArray.push(pairing?.player2);
            }
          });
        }
        if (parallelData.seatedPairings?.length) {
          parallelData.seatedPairings.forEach((pairing) => {
            if (pairing.seatedPlayers?.length) {
              for (let seatedPlayer of pairing.seatedPlayers) {
                if (seatedPlayer?.playerId) {
                  playersArray.push({
                    ...seatedPlayer,
                    name: seatedPlayer.playerName
                  });
                }
              }
            }
          });
        }
      }

      if (playersArray.length) {
        playersArray.sort((a, b) => {
          var nameA = a?.name?.toLowerCase();
          var nameB = b?.name?.toLowerCase();
          if (nameA > nameB) return 1;
          if (nameA < nameB) return -1;
          return 0;
        });
      }

      if (
        event.doublesEvent ||
        event.teamEvent ||
        event?.format?.doublesEvent ||
        event?.format?.teamEvent
      ) {
        setPairings(parallelData.teamPairings);
      } else if (event?.boardGameEvent || event?.format?.boardGameEvent) {
        setPairings(parallelData.seatedPairings);
      } else {
        setPairings(parallelData.pairings);
      }

      setPlayers(playersArray);
      setSubLoading(false);
    } catch (err) {
      console.error(err);
      postNotification("error", err);
    }
  };

  const handlePairingStatus = async (status, progress) => {
    if (status !== pairingStatus) setPairingStatus(status);
    if (status === "pending_generate") {
      await delay(1000);
      if (progress <= 90) {
        progress += 5;
        setPairingProgress(progress);
      }
      try {
        var apiGetData = await getData(`/events/${event.id}/pairingsStatus`);
        if (apiGetData.status)
          await handlePairingStatus(apiGetData.status, progress);
      } catch (err) {
        await handlePairingStatus(status, progress);
      }
    } else if (status === "active") {
      setPairingProgress(100);
      setPairingStatus(null);
      postNotification("success", t("notifications.success.pairingsGenerated"));
      setEvent({
        ...event,
        status: {
          ...event.status,
          currentRound: getCurrentRound(event) + 1,
          started: true
        }
      });
      changeRound(roundNo + 1);

      try {
        await confirm({
          title: `Set up Timer`,
          description: "Would you like to set up your round timer now?",
          dialogProps: {
            sx: {
              zIndex: 99999
            }
          },
          confirmationText: "Yes",
          cancellationText: "Later"
        });

        setRoundTimerOptions(event);
      } catch (err) {}
    } else if (status === "failed") {
      postNotification(
        "error",
        t("notifications.errors.errorGeneratingPairings")
      );
      setPairingProgress(0);
      setPairingStatus(null);
    }
  };

  // Used to add a slight delay before fetching round data when quickly switching between multiple rounds (1.5 seconds)
  const handleClick = (action) => {
    const interval = 1000;
    setRoundUpdating(true);

    if (action === "inc") {
      if (_roundNo < getCurrentRound(event)) {
        set_RoundNo(_roundNo + 1);
        setTimer(
          setTimeout(() => {
            changeRound(_roundNo + 1);
            setSubLoading(false);
          }, interval)
        );
      } else if (_roundNo === getCurrentRound(event)) {
        set_RoundNo(roundNo);
        setTimer(
          setTimeout(() => {
            changeRound(_roundNo);
            setSubLoading(false);
          }, interval)
        );
      }
    } else {
      if (_roundNo > 1) {
        set_RoundNo(_roundNo - 1);
        setTimer(
          setTimeout(() => {
            changeRound(_roundNo - 1);
            setSubLoading(false);
          }, interval)
        );
      } else if (_roundNo === 1) {
        set_RoundNo(roundNo);
        setTimer(
          setTimeout(() => {
            changeRound(_roundNo);
            setSubLoading(false);
          }, interval)
        );
      }
    }

    // Reset the timer every time the button is clicked
    clearTimeout(timer);
  };

  const changeRound = (round) => {
    setSubLoading(true);

    // Clears existing pairings to allow new pairings to load properly
    refreshPairingsFunc(false);
    setPairings(null);

    var path = newPath({
      round: round
    });
    navigate(path, { replace: false });
    setRoundNo(round);
    set_RoundNo(round);
  };

  const postSoftScoreSubmit = (softScorePairing) => {
    if (organize) {
      let newPairings = pairings;
      let found = false;
      for (let i = 0; i < newPairings?.length; i++) {
        if (softScorePairing?.parentPairingId === newPairings[i].id) {
          for (let x = 0; x < newPairings[i].player1SoftScores?.length; x++) {
            if (
              newPairings[i].player1SoftScores[x].softScore?.id ===
              softScorePairing.softScoreId
            ) {
              if (
                (softScorePairing?.playerId &&
                  softScorePairing?.playerId === newPairings[i].player1Id) ||
                (softScorePairing?.byePlayer && !newPairings[i].player1Id)
              ) {
                newPairings[i].player1SoftScores[x] = {
                  ...softScorePairing,
                  softScore: newPairings[i].player1SoftScores[x].softScore
                };
                found = true;
                break;
              } else if (
                (softScorePairing?.playerId &&
                  softScorePairing?.playerId === newPairings[i].player2Id) ||
                (softScorePairing?.byePlayer && !newPairings[i].player2Id)
              ) {
                newPairings[i].player2SoftScores[x] = {
                  ...softScorePairing,
                  softScore: newPairings[i].player2SoftScores[x].softScore
                };
                found = true;
                break;
              }
            }
          }

          if (found) {
            break;
          }
        }
      }
      setPairings(newPairings);
    }
  };

  useEffect(() => {
    return () => clearTimeout(timer);
  }, [timer]);

  // Syncs roundNo and _roundNo after initial load
  useEffect(() => {
    if (roundNo && !_roundNo && !_roundNo !== 0) {
      set_RoundNo(roundNo);
    }
    // eslint-disable-next-line
  }, [roundNo, _roundNo]);

  useEffect(() => {
    const go = async () => {
      setTriggerHandlePairingStatus(false);
      handlePairingStatus("pending_generate", 5);
      setTopCutOptions(null);
      await delay(1000);
      setLoading(false);
    };
    if (triggerHandlePairingStatus) {
      go();
    }
    // eslint-disable-next-line
  }, [triggerHandlePairingStatus]);

  useEffect(() => {
    const check = async () => {
      try {
        if (organize && activeTab !== 1) return;
        if (!organize && activeTab !== 2) return;
        if (event) {
          if (roundNo === null) {
            const resetInitialRound = findGetParameter("round");
            var round =
              resetInitialRound !== undefined &&
              getIntegerFromString(resetInitialRound) > 0 &&
              getIntegerFromString(resetInitialRound) <= getCurrentRound(event)
                ? getIntegerFromString(resetInitialRound)
                : getCurrentRound(event);
            setRoundNo(round);
          }
        }
      } catch (err) {
        postNotification("error", err);
      }
    };
    check();
    // eslint-disable-next-line
  }, [activeTab, event]);

  useEffect(() => {
    const check = async () => {
      try {
        if (roundNo === null) return;
        if (roundNo > 0) {
          if (event) {
            if (getCurrentRound(event) === roundNo) {
              if (event?.roundTimers?.[roundNo]) {
                setTimerData(event.roundTimers[roundNo]);
              } else if (!event.roundTimers) {
                const apiTimer = await getData(`/events/${event?.id}/timer`, {
                  queryStringParameters: {
                    round: roundNo
                  }
                });
                if (apiTimer && Object.keys(apiTimer).length) {
                  setTimerData(apiTimer);
                }
              }
            }
          }
        }

        // Resets existing pairings
        setPlayers(null);
        setPairings(null);

        if (event?.status?.started && !event?.status?.ended)
          await handleWSConnection(roundNo);
        await handlePairings(roundNo);
      } catch (err) {
        setSocketStatus("Disconnected");
        postNotification("error", err);
      }
    };

    check();
    // eslint-disable-next-line
  }, [roundNo]);

  useEffect(() => {
    const check = async () => {
      try {
        if (!refreshPairings) return;
        await handlePairings(roundNo);
      } catch (err) {
        postNotification("error", err);
      }
      setRefreshPairings(false);
    };
    check();
    // eslint-disable-next-line
  }, [refreshPairings]);

  // Handles pairings filtering
  useEffect(() => {
    if (pairings?.length) {
      switch (filterType) {
        case "Submitted":
          setFilteredPairings(pairings.filter((pairing) => pairing?.isDone));
          break;

        case "Unsubmitted":
          setFilteredPairings(pairings.filter((pairing) => !pairing?.isDone));
          break;

        case "Teams With Pairings":
          setFilteredPairings(
            pairings.filter((pairing) => pairing?.pairings?.length)
          );
          break;

        case "Teams Without Pairings":
          setFilteredPairings(
            pairings.filter((pairing) => !pairing?.pairings?.length)
          );

          break;

        default:
          setFilteredPairings(null);
          setFilterType("");
      }
    }

    // eslint-disable-next-line
  }, [filterType, pairings]);

  // Runs whenever a new WS message is received
  useEffect(() => {
    handleMessages(webSocket, "Pairing");
    // eslint-disable-next-line
  }, [webSocket.lastMessage]);

  useEffect(() => {
    setSubLoading(false);
  }, [pairings]);

  useEffect(() => {
    const go = async () => {
      await checkStatus();
      window.addEventListener("offline", () => {
        setSocketStatus("Disconnected");
        setPSocketUrl(null);
      });
    };
    go();
    // eslint-disable-next-line
  }, []);

  useInterval(() => {
    checkStatus();
  }, 15000);

  return (
    <EventPairingsDefault
      activeTab={activeTab}
      handleTabChange={handleTabChange}
      event={event}
      setEvent={setEvent}
      organize={organize}
      authContext={authContext}
      setResetModalOpen={setResetModalOpen}
      roundNo={roundNo}
      timerData={timerData}
      setTimerData={setTimerData}
      loading={loading}
      subLoading={subLoading}
      setLoading={setLoading}
      setPlayer={setPlayer}
      player={player}
      pairing={pairing}
      pairings={pairings}
      setPairing={setPairing}
      setTeamPairing={setTeamPairing}
      setTeamPlayer={setTeamPlayer}
      setSeatedPairing={setSeatedPairing}
      setPairingPopUp={setPairingPopUp}
      setEndEventModal={setEndEventModal}
      setPairingProgress={setPairingProgress}
      setPairingStatus={setPairingStatus}
      changeRound={changeRound}
      handlePairingStatus={handlePairingStatus}
      optionsAnchorEl={optionsAnchorEl}
      setOptionsAnchorEl={setOptionsAnchorEl}
      setCreatePairingModal={setCreatePairingModal}
      setOptionsAnchorEl2={setOptionsAnchorEl2}
      setOptionsAnchorEl4={setOptionsAnchorEl4}
      setOptionsAnchorEl5={setOptionsAnchorEl5}
      setOptionsAnchorEl6={setOptionsAnchorEl6}
      postSoftScoreSubmit={postSoftScoreSubmit}
      setRoundTimerOptions={setRoundTimerOptions}
      setTopCutOptions={setTopCutOptions}
      setRefreshPairings={setRefreshPairings}
      optionsAnchorEl2={optionsAnchorEl2}
      optionsAnchorEl4={optionsAnchorEl4}
      optionsAnchorEl5={optionsAnchorEl5}
      optionsAnchorEl6={optionsAnchorEl6}
      setArmyModalOpen={setArmyModalOpen}
      setSwapPlayerModal={setSwapPlayerModal}
      teamPairing={teamPairing}
      teamPlayer={teamPlayer}
      seatedPairing={seatedPairing}
      setSwapSeatedPairingModal={setSwapSeatedPairingModal}
      setSwapSeatNumberModal={setSwapSeatNumberModal}
      setSwapTeamModal={setSwapTeamModal}
      pairingPopUp={pairingPopUp}
      setSwapTableModal={setSwapTableModal}
      roundTimerOptions={roundTimerOptions}
      topCutOptions={topCutOptions}
      setTriggerHandlePairingStatus={setTriggerHandlePairingStatus}
      endEventModal={endEventModal}
      armyModalOpen={armyModalOpen}
      swapPlayerModal={swapPlayerModal}
      players={players}
      teamPlayers={[]}
      swapTeamModal={swapTeamModal}
      swapSeatNumberModal={swapSeatNumberModal}
      swapSeatedPairingModal={swapSeatedPairingModal}
      swapTableModal={swapTableModal}
      pairingProgress={pairingProgress}
      pairingStatus={pairingStatus}
      createPairingModal={createPairingModal}
      filtersAnchorEl={filtersAnchorEl}
      setFiltersAnchorEl={setFiltersAnchorEl}
      filteredPairings={filteredPairings}
      filterType={filterType}
      setFilterType={setFilterType}
      setSubLoading={setSubLoading}
      handleClick={handleClick}
      _roundNo={_roundNo}
      useWebSockets={true}
      placingsReady={placingsReady}
      socketStatus={socketStatus}
      handleWSConnection={handleWSConnection}
      handlePairings={handlePairings}
      setRoundUpdating={setRoundUpdating}
      betweenRoundsModal={betweenRoundsModal}
      setBetweenRoundsModal={setBetweenRoundsModal}
    />
  );
}
